import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import VehicleCard from "@/components/VehicleCard";
import { fetchVehicles } from "@/api";

export default function FleetPreview() {
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    fetchVehicles()
      .then((data) => setVehicles(data.slice(0, 3)))
      .catch(() => setVehicles([]));
  }, []);

  if (vehicles.length === 0) return null;

  return (
    <section data-testid="fleet-preview-section" className="py-24 md:py-32 bg-[#0A1C45]">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-sky-300 font-bold mb-4">Current stock</p>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-white">
                Ready for their next driver.
              </h2>
            </div>
            <Link
              to="/vehicles"
              data-testid="fleet-view-all-link"
              className="inline-flex items-center gap-2 text-sm font-bold text-[#87CEEB] hover:text-white transition-colors"
            >
              View the full catalogue <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {vehicles.map((v, i) => (
            <Reveal key={v.slug} delay={i * 0.1}>
              <VehicleCard v={v} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
